import { useEffect, useCallback } from "react";

let timer;

const useUpdateFiltersAndUrl = (appliedCheckboxes) => {
  const stringifiedFilters = JSON.stringify(appliedCheckboxes);
  const stringifiedAppliedCheckboxes = JSON.stringify(appliedCheckboxes);
  const debounceUrlUpdate = useCallback(() => {
    clearTimeout(timer);
    timer = setTimeout(() => {}, 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stringifiedAppliedCheckboxes]);

  useEffect(() => {
    debounceUrlUpdate();
  }, [stringifiedFilters, debounceUrlUpdate]);
};

export default useUpdateFiltersAndUrl;
